<template>
  <div class="myDatePickerContainer" @click="showPicker" id="myDatePickerContainer">
    <div class="dateShowContainer">
      <i class="icon-calendar"></i>
      <el-input v-model="rangeStart"></el-input>
      <span>{{ innerRangeSeparator }}</span>
      <el-input v-model="rangeEnd"></el-input>
    </div>
    <div class="pickerContainer" v-show="showMonth">
      <div class="leftPicker">
        <div class="pickerHeader">
          <button
            type="button"
            class="el-picker-panel__icon-btn el-icon-d-arrow-left"
            @click="changeYear(0, -1)"
          ></button>
          <div>{{ monthYear - 1 }} 年</div>
        </div>
        <table class="pickerTable">
          <tr>
            <td
              @click="clickMonth(1, '01')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '01',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '01',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '01' &&
                  monthYear - 1 + '01' <= maxMonthValue,
                disabled: checkDisableBtn('month', 1),
              }"
            >
              <div class="cell">一月</div>
            </td>
            <td
              @click="clickMonth(1, '02')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '02',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '02',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '02' &&
                  monthYear - 1 + '02' <= maxMonthValue,
                disabled: checkDisableBtn('month', 2),
              }"
            >
              <div class="cell">二月</div>
            </td>
            <td
              @click="clickMonth(1, '03')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '03',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '03',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '03' &&
                  monthYear - 1 + '03' <= maxMonthValue,
                disabled: checkDisableBtn('month', 3),
              }"
            >
              <div class="cell">三月</div>
            </td>
            <td
              @click="clickMonth(1, '04')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '04',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '04',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '04' &&
                  monthYear - 1 + '04' <= maxMonthValue,
                disabled: checkDisableBtn('month', 4),
              }"
            >
              <div class="cell">四月</div>
            </td>
          </tr>
          <tr>
            <td
              @click="clickMonth(1, '05')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '05',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '05',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '05' &&
                  monthYear - 1 + '05' <= maxMonthValue,
                disabled: checkDisableBtn('month', 5),
              }"
            >
              <div class="cell">五月</div>
            </td>
            <td
              @click="clickMonth(1, '06')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '06',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '06',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '06' &&
                  monthYear - 1 + '06' <= maxMonthValue,
                disabled: checkDisableBtn('month', 6),
              }"
            >
              <div class="cell">六月</div>
            </td>
            <td
              @click="clickMonth(1, '07')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '07',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '07',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '07' &&
                  monthYear - 1 + '07' <= maxMonthValue,
                disabled: checkDisableBtn('month', 7),
              }"
            >
              <div class="cell">七月</div>
            </td>
            <td
              @click="clickMonth(1, '08')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '08',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '08',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '08' &&
                  monthYear - 1 + '08' <= maxMonthValue,
                disabled: checkDisableBtn('month', 8),
              }"
            >
              <div class="cell">八月</div>
            </td>
          </tr>
          <tr>
            <td
              @click="clickMonth(1, '09')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '09',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '09',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '09' &&
                  monthYear - 1 + '09' <= maxMonthValue,
                disabled: checkDisableBtn('month', 9),
              }"
            >
              <div class="cell">九月</div>
            </td>
            <td
              @click="clickMonth(1, '10')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '10',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '10',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '10' &&
                  monthYear - 1 + '10' <= maxMonthValue,
                disabled: checkDisableBtn('month', 10),
              }"
            >
              <div class="cell">十月</div>
            </td>
            <td
              @click="clickMonth(1, '11')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '11',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '11',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '11' &&
                  monthYear - 1 + '11' <= maxMonthValue,
                disabled: checkDisableBtn('month', 11),
              }"
            >
              <div class="cell">十一月</div>
            </td>
            <td
              @click="clickMonth(1, '12')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear - 1 + '12',
                selectRightCls: slectRightMonthBtn === monthYear - 1 + '12',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear - 1 + '12' &&
                  monthYear - 1 + '12' <= maxMonthValue,
                disabled: checkDisableBtn('month', 12),
              }"
            >
              <div class="cell">十二月</div>
            </td>
          </tr>
        </table>
      </div>
      <div class="rightPicker">
        <div class="pickerHeader">
          <div>{{ monthYear }} 年</div>
          <button
            type="button"
            class="el-picker-panel__icon-btn el-icon-d-arrow-right"
            @click="changeYear(0, 1)"
          ></button>
        </div>
        <table class="pickerTable">
          <tr>
            <td
              @click="clickMonth(2, '13')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '01',
                selectRightCls: slectRightMonthBtn === monthYear + '01',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '01' &&
                  monthYear + '01' <= maxMonthValue,
                disabled: checkDisableBtn('month', 13),
              }"
            >
              <div class="cell">一月</div>
            </td>
            <td
              @click="clickMonth(2, '14')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '02',
                selectRightCls: slectRightMonthBtn === monthYear + '02',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '02' &&
                  monthYear + '02' <= maxMonthValue,
                disabled: checkDisableBtn('month', 14),
              }"
            >
              <div class="cell">二月</div>
            </td>
            <td
              @click="clickMonth(2, '15')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '03',
                selectRightCls: slectRightMonthBtn === monthYear + '03',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '03' &&
                  monthYear + '03' <= maxMonthValue,
                disabled: checkDisableBtn('month', 15),
              }"
            >
              <div class="cell">三月</div>
            </td>
            <td
              @click="clickMonth(2, '16')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '04',
                selectRightCls: slectRightMonthBtn === monthYear + '04',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '04' &&
                  monthYear + '04' <= maxMonthValue,
                disabled: checkDisableBtn('month', 16),
              }"
            >
              <div class="cell">四月</div>
            </td>
          </tr>
          <tr>
            <td
              @click="clickMonth(2, '17')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '05',
                selectRightCls: slectRightMonthBtn === monthYear + '05',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '05' &&
                  monthYear + '05' <= maxMonthValue,
                disabled: checkDisableBtn('month', 17),
              }"
            >
              <div class="cell">五月</div>
            </td>
            <td
              @click="clickMonth(2, '18')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '06',
                selectRightCls: slectRightMonthBtn === monthYear + '06',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '06' &&
                  monthYear + '06' <= maxMonthValue,
                disabled: checkDisableBtn('month', 18),
              }"
            >
              <div class="cell">六月</div>
            </td>
            <td
              @click="clickMonth(2, '19')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '07',
                selectRightCls: slectRightMonthBtn === monthYear + '07',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '07' &&
                  monthYear + '07' <= maxMonthValue,
                disabled: checkDisableBtn('month', 19),
              }"
            >
              <div class="cell">七月</div>
            </td>
            <td
              @click="clickMonth(2, '20')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '08',
                selectRightCls: slectRightMonthBtn === monthYear + '08',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '08' &&
                  monthYear + '08' <= maxMonthValue,
                disabled: checkDisableBtn('month', 20),
              }"
            >
              <div class="cell">八月</div>
            </td>
          </tr>
          <tr>
            <td
              @click="clickMonth(2, '21')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '09',
                selectRightCls: slectRightMonthBtn === monthYear + '09',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '09' &&
                  monthYear + '09' <= maxMonthValue,
                disabled: checkDisableBtn('month', 21),
              }"
            >
              <div class="cell">九月</div>
            </td>
            <td
              @click="clickMonth(2, '22')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '10',
                selectRightCls: slectRightMonthBtn === monthYear + '10',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '10' &&
                  monthYear + '10' <= maxMonthValue,
                disabled: checkDisableBtn('month', 22),
              }"
            >
              <div class="cell">十月</div>
            </td>
            <td
              @click="clickMonth(2, '23')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '11',
                selectRightCls: slectRightMonthBtn === monthYear + '11',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '11' &&
                  monthYear + '11' <= maxMonthValue,
                disabled: checkDisableBtn('month', 23),
              }"
            >
              <div class="cell">十一月</div>
            </td>
            <td
              @click="clickMonth(2, '24')"
              :class="{
                selectLeftCls: slectLeftMonthBtn === monthYear + '12',
                selectRightCls: slectRightMonthBtn === monthYear + '12',
                centerBtnCls:
                  null != minMonthValue &&
                  null != maxMonthValue &&
                  minMonthValue <= monthYear + '12' &&
                  monthYear + '12' <= maxMonthValue,
                disabled: checkDisableBtn('month', 24),
              }"
            >
              <div class="cell">十二月</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="pickerContainer quarterContainer" v-show="showQuarter">
      <div class="leftPicker">
        <div class="pickerHeader">
          <button
            type="button"
            class="el-picker-panel__icon-btn el-icon-d-arrow-left"
            @click="changeYear(1, -1)"
          ></button>
          <div>{{ quarterYear - 1 }} 年</div>
        </div>
        <table class="pickerTable">
          <tr>
            <td
              @click="clickQuarter(1, '1')"
              :class="{
                selectLeftCls: slectLeftQuarterBtn === quarterYear - 1 + '1',
                selectRightCls: slectRightQuarterBtn === quarterYear - 1 + '1',
                centerBtnCls:
                  null != minQuarterValue &&
                  null != maxQuarterValue &&
                  minQuarterValue <= quarterYear - 1 + '1' &&
                  quarterYear - 1 + '1' <= maxQuarterValue,
                disabled: checkDisableBtn('quarter', 1),
              }"
            >
              <div class="cell">第一季度</div>
            </td>
            <td
              @click="clickQuarter(1, '2')"
              :class="{
                selectLeftCls: slectLeftQuarterBtn === quarterYear - 1 + '2',
                selectRightCls: slectRightQuarterBtn === quarterYear - 1 + '2',
                centerBtnCls:
                  null != minQuarterValue &&
                  null != maxQuarterValue &&
                  minQuarterValue <= quarterYear - 1 + '2' &&
                  quarterYear - 1 + '2' <= maxQuarterValue,
                disabled: checkDisableBtn('quarter', 2),
              }"
            >
              <div class="cell">第二季度</div>
            </td>
          </tr>
          <tr>
            <td
              @click="clickQuarter(1, '3')"
              :class="{
                selectLeftCls: slectLeftQuarterBtn === quarterYear - 1 + '3',
                selectRightCls: slectRightQuarterBtn === quarterYear - 1 + '3',
                centerBtnCls:
                  null != minQuarterValue &&
                  null != maxQuarterValue &&
                  minQuarterValue <= quarterYear - 1 + '3' &&
                  quarterYear - 1 + '3' <= maxQuarterValue,
                disabled: checkDisableBtn('quarter', 3),
              }"
            >
              <div class="cell">第三季度</div>
            </td>
            <td
              @click="clickQuarter(1, '4')"
              :class="{
                selectLeftCls: slectLeftQuarterBtn === quarterYear - 1 + '4',
                selectRightCls: slectRightQuarterBtn === quarterYear - 1 + '4',
                centerBtnCls:
                  null != minQuarterValue &&
                  null != maxQuarterValue &&
                  minQuarterValue <= quarterYear - 1 + '4' &&
                  quarterYear - 1 + '4' <= maxQuarterValue,
                disabled: checkDisableBtn('quarter', 4),
              }"
            >
              <div class="cell">第四季度</div>
            </td>
          </tr>
        </table>
      </div>
      <div class="rightPicker">
        <div class="pickerHeader">
          <button
            type="button"
            class="el-picker-panel__icon-btn el-icon-d-arrow-right"
            @click="changeYear(1, 1)"
          ></button>
          <div>{{ quarterYear }} 年</div>
        </div>
        <table class="pickerTable">
          <tr>
            <td
              @click="clickQuarter(2, '5')"
              :class="{
                selectLeftCls: slectLeftQuarterBtn === quarterYear + '1',
                selectRightCls: slectRightQuarterBtn === quarterYear + '1',
                centerBtnCls:
                  null != minQuarterValue &&
                  null != maxQuarterValue &&
                  minQuarterValue <= quarterYear + '1' &&
                  quarterYear + '1' <= maxQuarterValue,
                disabled: checkDisableBtn('quarter', 5),
              }"
            >
              <div class="cell">第一季度</div>
            </td>
            <td
              @click="clickQuarter(2, '6')"
              :class="{
                selectLeftCls: slectLeftQuarterBtn === quarterYear + '2',
                selectRightCls: slectRightQuarterBtn === quarterYear + '2',
                centerBtnCls:
                  null != minQuarterValue &&
                  null != maxQuarterValue &&
                  minQuarterValue <= quarterYear + '2' &&
                  quarterYear + '2' <= maxQuarterValue,
                disabled: checkDisableBtn('quarter', 6),
              }"
            >
              <div class="cell">第二季度</div>
            </td>
          </tr>
          <tr>
            <td
              @click="clickQuarter(2, '7')"
              :class="{
                selectLeftCls: slectLeftQuarterBtn === quarterYear + '3',
                selectRightCls: slectRightQuarterBtn === quarterYear + '3',
                centerBtnCls:
                  null != minQuarterValue &&
                  null != maxQuarterValue &&
                  minQuarterValue <= quarterYear + '3' &&
                  quarterYear + '3' <= maxQuarterValue,
                disabled: checkDisableBtn('quarter', 7),
              }"
            >
              <div class="cell">第三季度</div>
            </td>
            <td
              @click="clickQuarter(2, '8')"
              :class="{
                selectLeftCls: slectLeftQuarterBtn === quarterYear + '4',
                selectRightCls: slectRightQuarterBtn === quarterYear + '4',
                centerBtnCls:
                  null != minQuarterValue &&
                  null != maxQuarterValue &&
                  minQuarterValue <= quarterYear + '4' &&
                  quarterYear + '4' <= maxQuarterValue,
                disabled: checkDisableBtn('quarter', 8),
              }"
            >
              <div class="cell">第四季度</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="pickerContainer yearContainer" v-show="showYear">
      <div class="leftPicker">
        <div class="pickerHeader">
          <button
            type="button"
            class="el-picker-panel__icon-btn el-icon-d-arrow-left"
            @click="changeYearYear(0, -10)"
          ></button>
          <div>{{ yearYear + "-" + (yearYear + 9) }} 年</div>
          <button
            type="button"
            class="el-picker-panel__icon-btn el-icon-d-arrow-right"
            @click="changeYearYear(0, 10)"
          ></button>
        </div>
        <table class="pickerTable">
          <tr>
            <td
              @click="clickYear(1, 0)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear,
                selectRightCls: slectRightYearBtn === yearYear,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear &&
                  yearYear <= maxYearValue,
                disabled: checkDisableBtn('year', 0),
              }"
            >
              <div class="cell">{{ yearYear }}</div>
            </td>
            <td
              @click="clickYear(1, 1)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 1,
                selectRightCls: slectRightYearBtn === yearYear + 1,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 1 &&
                  yearYear + 1 <= maxYearValue,
                disabled: checkDisableBtn('year', 1),
              }"
            >
              <div class="cell">{{ yearYear + 1 }}</div>
            </td>
            <td
              @click="clickYear(1, 2)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 2,
                selectRightCls: slectRightYearBtn === yearYear + 2,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 2 &&
                  yearYear + 2 <= maxYearValue,
                disabled: checkDisableBtn('year', 2),
              }"
            >
              <div class="cell">{{ yearYear + 2 }}</div>
            </td>
            <td
              @click="clickYear(1, 3)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 3,
                selectRightCls: slectRightYearBtn === yearYear + 3,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 3 &&
                  yearYear + 3 <= maxYearValue,
                disabled: checkDisableBtn('year', 3),
              }"
            >
              <div class="cell">{{ yearYear + 3 }}</div>
            </td>
          </tr>
          <tr>
            <td
              @click="clickYear(1, 4)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 4,
                selectRightCls: slectRightYearBtn === yearYear + 4,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 4 &&
                  yearYear + 4 <= maxYearValue,
                disabled: checkDisableBtn('year', 4),
              }"
            >
              <div class="cell">{{ yearYear + 4 }}</div>
            </td>
            <td
              @click="clickYear(1, 5)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 5,
                selectRightCls: slectRightYearBtn === yearYear + 5,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 5 &&
                  yearYear + 5 <= maxYearValue,
                disabled: checkDisableBtn('year', 5),
              }"
            >
              <div class="cell">{{ yearYear + 5 }}</div>
            </td>
            <td
              @click="clickYear(1, 6)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 6,
                selectRightCls: slectRightYearBtn === yearYear + 6,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 6 &&
                  yearYear + 6 <= maxYearValue,
                disabled: checkDisableBtn('year', 6),
              }"
            >
              <div class="cell">{{ yearYear + 6 }}</div>
            </td>
            <td
              @click="clickYear(1, 7)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 7,
                selectRightCls: slectRightYearBtn === yearYear + 7,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 7 &&
                  yearYear + 7 <= maxYearValue,
                disabled: checkDisableBtn('year', 7),
              }"
            >
              <div class="cell">{{ yearYear + 7 }}</div>
            </td>
          </tr>
          <tr>
            <td
              @click="clickYear(1, 8)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 8,
                selectRightCls: slectRightYearBtn === yearYear + 8,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 8 &&
                  yearYear + 8 <= maxYearValue,
                disabled: checkDisableBtn('year', 8),
              }"
            >
              <div class="cell">{{ yearYear + 8 }}</div>
            </td>
            <td
              @click="clickYear(1, 9)"
              :class="{
                selectLeftCls: slectLeftYearBtn === yearYear + 9,
                selectRightCls: slectRightYearBtn === yearYear + 9,
                centerBtnCls:
                  null != minYearValue &&
                  null != maxYearValue &&
                  minYearValue <= yearYear + 9 &&
                  yearYear + 9 <= maxYearValue,
                disabled: checkDisableBtn('year', 9),
              }"
            >
              <div class="cell">{{ yearYear + 9 }}</div>
            </td>
            <td>
              <div class="cell"></div>
            </td>
            <td>
              <div class="cell"></div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
const _MONTH = "month";
const _QUARTER = "quarter";
const _YEAR = "year";

export default {
  name: "myDatePicker",
  props: ["type", "rangeSeparator"],
  data() {
    return {
      innerRangeSeparator: "~",
      rangeStart: "",
      rangeEnd: "",
      active: false,
      globalClickEvent: null,
      clickMonthArr: [],
      clickTempMonthArr: [],
      monthYear: 2021,
      minMonthValue: null,
      maxMonthValue: null,
      slectLeftMonthBtn: "",
      slectRightMonthBtn: "",
      quarterYear: 2021,
      clickQuarterArr: [],
      clickTempQuarterArr: [],
      minQuarterValue: null,
      maxQuarterValue: null,
      slectLeftQuarterBtn: "",
      slectRightQuarterBtn: "",
      yearYear: 2020,
      clickYearArr: [],
      clickTempYearArr: [],
      minYearValue: null,
      maxYearValue: null,
      slectLeftYearBtn: "",
      slectRightYearBtn: "",

      maxYear: "",
      maxMonth: "",
      maxQuarter: "",
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      const date = new Date();
      this.$data.maxMonth = date.getMonth() + 1;
      this.$data.maxQuarter = Math.ceil(this.$data.maxMonth / 3);
      this.$data.maxYear = date.getFullYear();
    },
    clickMonth(type, month) {
      this.$data.resetPickerFlag = false;
      let clickMonthArr = this.$data.clickMonthArr;
      //重复点击同一个元素直接返回
      let year = type === 1 ? this.$data.monthYear - 1 : this.$data.monthYear;
      // if (this.clickSameBtn(year, month, clickMonthArr, _MONTH)) {
      //   return;
      // }
      if (2 <= this.clickMonthArr.length) {
        clickMonthArr = this.$data.clickMonthArr = [];
        this.$data.slectLeftMonthBtn = "";
        this.$data.slectRightMonthBtn = "";
      }
      clickMonthArr.push({
        type,
        year: type === 1 ? this.$data.monthYear - 1 : this.$data.monthYear,
        month: month,
      });
      this.setClickMonthData(true);
      this.$forceUpdate();
    },
    clickSameBtn(year, value, arr, type) {
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        if (year === element.year && value === element[type]) {
          return true;
        }
      }
      return false;
    },
    setClickMonthData(click) {
      const clickMonthArr = this.$data.clickMonthArr;
      if (1 == clickMonthArr.length) {
        const ele = clickMonthArr[0];
        this.$data.minMonthValue = this.$data.slectLeftMonthBtn =
          ele.year + this.getMonth(ele.month);
        this.$data.maxMonthValue = null;
      } else if (2 == clickMonthArr.length) {
        let ele0 = null;
        let ele1 = null;
        if (
          clickMonthArr[0].year + clickMonthArr[0].month <
          clickMonthArr[1].year + clickMonthArr[1].month
        ) {
          ele0 = clickMonthArr[0];
          ele1 = clickMonthArr[1];
        } else {
          ele0 = clickMonthArr[1];
          ele1 = clickMonthArr[0];
        }
        this.$data.slectLeftMonthBtn = this.$data.minMonthValue =
          ele0.year + this.getMonth(ele0.month);
        this.$data.rangeStart = ele0.year + "-" + this.getMonth(ele0.month);
        this.$data.slectRightMonthBtn = this.$data.maxMonthValue =
          ele1.year + this.getMonth(ele1.month);
        this.$data.rangeEnd = ele1.year + "-" + this.getMonth(ele1.month);
        this.$data.clickTempMonthArr = this.$data.clickMonthArr;
        this.$emit("resetDateRange", this.$data.rangeStart + "~" + this.$data.rangeEnd);
        if (click) {
          this.$data.active = false;
          this.$data.resetPickerFlag = false;
        }
      }
    },
    clickQuarter(type, quarter) {
      this.$data.resetPickerFlag = false;
      let clickQuarterArr = this.$data.clickQuarterArr;
      //重复点击同一个元素直接返回
      let year = type === 1 ? this.$data.quarterYear - 1 : this.$data.quarterYear;
      // if (this.clickSameBtn(year, quarter, clickQuarterArr, _QUARTER)) {
      //   return;
      // }
      if (2 <= this.clickQuarterArr.length) {
        clickQuarterArr = this.$data.clickQuarterArr = [];
        this.$data.slectLeftQuarterBtn = "";
        this.$data.slectRightQuarterBtn = "";
      }
      clickQuarterArr.push({
        type,
        year: type === 1 ? this.$data.quarterYear - 1 : this.$data.quarterYear,
        quarter: quarter,
      });
      this.setClickQuarterData(true);
      this.$forceUpdate();
    }, //click 判断是重置时间范围选择框还是点击时间选择框
    setClickQuarterData(click) {
      const clickQuarterArr = this.$data.clickQuarterArr;
      if (1 == clickQuarterArr.length) {
        const ele = clickQuarterArr[0];
        this.$data.minQuarterValue = this.$data.slectLeftQuarterBtn =
          ele.year + this.getQuarter(ele.quarter);
        this.$data.maxQuarterValue = null;
      } else if (2 == clickQuarterArr.length) {
        let ele0 = null;
        let ele1 = null;
        if (
          clickQuarterArr[0].year + clickQuarterArr[0].quarter <
          clickQuarterArr[1].year + clickQuarterArr[1].quarter
        ) {
          ele0 = clickQuarterArr[0];
          ele1 = clickQuarterArr[1];
        } else {
          ele0 = clickQuarterArr[1];
          ele1 = clickQuarterArr[0];
        }
        this.$data.minQuarterValue = this.$data.slectLeftQuarterBtn =
          ele0.year + this.getQuarter(ele0.quarter);
        this.$data.rangeStart = ele0.year + "-" + this.getQuarter(ele0.quarter);
        this.$data.maxQuarterValue = this.$data.slectRightQuarterBtn =
          ele1.year + this.getQuarter(ele1.quarter);
        this.$data.rangeEnd = ele1.year + "-" + this.getQuarter(ele1.quarter);
        this.$data.clickTempQuarterArr = this.$data.clickQuarterArr;
        this.$emit("resetDateRange", this.$data.rangeStart + "~" + this.$data.rangeEnd);
        if (click) {
          this.$data.active = false;
          this.$data.resetPickerFlag = false;
        }
      }
    },
    getQuarter(data) {
      if (4 < parseInt(data)) {
        data = parseInt(data) - 4;
      }
      return data + "";
    },
    getMonth(data) {
      if (12 < parseInt(data)) {
        let newData = parseInt(data) - 12;
        if (newData < 10) {
          data = "0" + newData;
        } else {
          data = "" + newData;
        }
      }
      return data;
    },
    clickYear(type, year) {
      this.$data.resetPickerFlag = false;
      let clickYearArr = this.$data.clickYearArr;
      //重复点击同一个元素直接返回
      let year0 = this.$data.yearYear + year;
      // if (this.clickSameBtn(year0, year0, clickYearArr, _YEAR)) {
      //   return;
      // }
      if (2 <= this.clickYearArr.length) {
        clickYearArr = this.$data.clickYearArr = [];
        this.$data.slectLeftYearBtn = "";
        this.$data.slectRightYearBtn = "";
      }
      clickYearArr.push({
        year: this.$data.yearYear + year,
      });
      this.setClickYearData(true);
      this.$forceUpdate();
    },
    setClickYearData(click) {
      const clickYearArr = this.$data.clickYearArr;
      if (1 == clickYearArr.length) {
        const ele = clickYearArr[0];
        this.$data.minYearValue = this.$data.slectLeftYearBtn = ele.year;
        this.$data.maxYearValue = null;
      } else if (2 == clickYearArr.length) {
        let ele0 = null;
        let ele1 = null;
        if (
          clickYearArr[0].year + clickYearArr[0].year <
          clickYearArr[1].year + clickYearArr[1].year
        ) {
          ele0 = clickYearArr[0];
          ele1 = clickYearArr[1];
        } else {
          ele0 = clickYearArr[1];
          ele1 = clickYearArr[0];
        }
        this.$data.rangeStart = this.$data.minYearValue = this.$data.slectLeftYearBtn =
          ele0.year;
        this.$data.rangeEnd = this.$data.maxYearValue = this.$data.slectRightYearBtn =
          ele1.year;
        this.$data.clickTempYearArr = this.$data.clickYearArr;
        this.$emit("resetDateRange", this.$data.rangeStart + "~" + this.$data.rangeEnd);
        if (click) {
          this.$data.active = false;
          this.$data.resetPickerFlag = false;
        }
      }
    },
    changeYear(type, value) {
      this.$data.resetPickerFlag = false;
      if (type === 0) {
        this.$data.monthYear += value;
        this.setClickMonthData();
      } else {
        this.$data.quarterYear += value;
        this.setClickQuarterData();
      }
      this.$forceUpdate();
    },
    changeYearYear(type, value) {
      this.$data.yearYear += value;
      this.$data.resetPickerFlag = false;
      this.setClickYearData();
      this.$forceUpdate();
    },
    showPicker(e) {
      if (false !== this.$data.resetPickerFlag) {
        const type = this.type;
        this.$data.active = true;
        this.resetPicker();
        e.preventDefault();
        this.addEvent();
      } else {
        this.$data.resetPickerFlag = null;
      }
    }, //重新设置时间选择器的信息
    resetPicker(mark) {
      const type = mark ? mark : this.type;
      if (_MONTH === type) {
        this.$data.clickMonthArr = this.$data.clickTempMonthArr;
        this.setClickMonthData();
      } else if (_QUARTER === type) {
        this.$data.clickQuarterArr = this.$data.clickTempQuarterArr;
        this.setClickQuarterData();
      } else if (_YEAR === type) {
        this.$data.clickYearArr = this.$data.clickTempYearArr;
        this.setClickYearData();
      }
    },
    addEvent() {
      if (!this.$data.globalClickEvent) {
        const clickEvent = (this.$data.globalClickEvent = (e) => {
          if (!this.checkDatePicker(e.target)) {
            this.$data.active = false;
            this.clearEvent();
          }
        });
        window.addEventListener("click", clickEvent);
      }
    },
    clearEvent() {
      const globalClickEvent = this.$data.globalClickEvent;
      if (globalClickEvent) {
        window.removeEventListener("click", globalClickEvent);
        this.$data.globalClickEvent = null;
      }
    },
    checkDatePicker(ele) {
      while (ele) {
        if ("myDatePickerContainer" === ele.getAttribute("id")) {
          return true;
        }
        ele = ele.parentElement;
      }
      return false;
    },
    resetPickerTime(type, dateRange) {
      const dateRangeArr = dateRange.split("~");
      this.$data.rangeStart = dateRangeArr[0];
      this.$data.rangeEnd = dateRangeArr[1];
      if (_MONTH === type) {
        const clickTempMonthArr = (this.$data.clickTempMonthArr = []);
        const startTimeArr = dateRangeArr[0].split("-");
        const endTimeArr = dateRangeArr[1].split("-");
        if (startTimeArr[0] === endTimeArr[0]) {
          clickTempMonthArr.push({
            type: 1,
            year: startTimeArr[0],
            month: startTimeArr[1],
          });
          clickTempMonthArr.push({
            type: 1,
            year: endTimeArr[0],
            month: endTimeArr[1],
          });
        } else {
          clickTempMonthArr.push({
            type: 1,
            year: startTimeArr[0],
            month: startTimeArr[1],
          });
          clickTempMonthArr.push({
            type: 2,
            year: endTimeArr[0],
            month: "" + (parseInt(endTimeArr[1]) + 12),
          });
        }
      } else if (_QUARTER === type) {
        const clickTempQuarterArr = (this.$data.clickTempQuarterArr = []);
        const startTimeArr2 = dateRangeArr[0].split("-");
        const endTimeArr2 = dateRangeArr[1].split("-");
        if (startTimeArr2[0] === endTimeArr2[0]) {
          clickTempQuarterArr.push({
            type: 1,
            year: startTimeArr2[0],
            quarter: startTimeArr2[1],
          });
          clickTempQuarterArr.push({
            type: 1,
            year: endTimeArr2[0],
            quarter: endTimeArr2[1],
          });
        } else {
          clickTempQuarterArr.push({
            type: 1,
            year: startTimeArr2[0],
            quarter: startTimeArr2[1],
          });
          clickTempQuarterArr.push({
            type: 2,
            year: endTimeArr2[0],
            quarter: "" + (parseInt(endTimeArr2[1]) + 4),
          });
        }
      } else if (_YEAR === type) {
        const clickTempYearArr = (this.$data.clickTempYearArr = []);
        clickTempYearArr.push({ year: parseInt(dateRangeArr[0]) });
        clickTempYearArr.push({ year: parseInt(dateRangeArr[1]) });
      }
      this.resetPicker(type);
    },
    checkDisableBtn(mark, time) {
      if (_MONTH === mark) {
        const year = time <= 12 ? this.$data.monthYear - 1 : this.$data.monthYear;
        if (12 < time) {
          time -= 12;
        }
        if (
          this.$data.maxYear < year ||
          (this.$data.maxYear == year && this.$data.maxMonth < time)
        ) {
          return true;
        }
        const clickArr = this.$data.clickMonthArr;
        if (clickArr && 1 == clickArr.length) {
          const ele = clickArr[0];
          let currentYear = parseInt(ele.year);
          let currentMonth = parseInt(ele.month);
          currentMonth = currentMonth <= 12 ? currentMonth : currentMonth - 12;
          if (
            year + 1 < currentYear ||
            currentYear < year - 1 ||
            (year < currentYear && time <= currentMonth) ||
            (currentYear < year && currentMonth <= time)
          ) {
            return true;
          }
        }
      } else if (_QUARTER === mark) {
        const year = time <= 4 ? this.$data.quarterYear - 1 : this.$data.quarterYear;
        time = time <= 4 ? time : time - 4;
        if (
          this.$data.maxYear < year ||
          (this.$data.maxYear == year && this.$data.maxQuarter < time)
        ) {
          return true;
        }

        let counter = 0;
        const clickArr = this.$data.clickQuarterArr;
        if (clickArr && 1 == clickArr.length) {
          const ele = clickArr[0];
          let currentYear = parseInt(ele.year);
          let currentQuarter = parseInt(ele.quarter);
          let startYear, startQuarter, endYear, endQuarter;
          if (year < currentYear) {
            startYear = year;
            startQuarter = time;
            endYear = currentYear;
            endQuarter = currentQuarter;
          } else if (year == currentYear) {
            startYear = year;
            startQuarter = time < currentQuarter ? time : currentQuarter;
            endYear = currentYear;
            endQuarter = time < currentQuarter ? currentQuarter : time;
          } else {
            startYear = currentYear;
            startQuarter = currentQuarter;
            endYear = year;
            endQuarter = time;
          }
          while (
            startYear < endYear ||
            (startYear == endYear && startQuarter <= endQuarter)
          ) {
            counter++;
            startQuarter++;
            if (4 < startQuarter) {
              startQuarter = 1;
              startYear++;
            }
          }
          if (12 < counter) {
            return true;
          }
        }
      } else if (_YEAR === mark) {
        time += this.$data.yearYear;
        if (this.$data.maxYear < time) {
          return true;
        }
        const clickArr = this.$data.clickYearArr;
        if (
          clickArr &&
          1 == clickArr.length &&
          11 < Math.abs(time - parseInt(clickArr[0].year))
        ) {
          return true;
        }
      }
      return false;
    },
  },
  computed: {
    showMonth() {
      return this.type === _MONTH && this.$data.active;
    },
    showQuarter() {
      return this.type === _QUARTER && this.$data.active;
    },
    showYear() {
      return this.type === _YEAR && this.$data.active;
    },
  },
  watch: {
    rangeSeparator: function (nval, oval) {
      if (!this.isEmptyStr(nval)) {
        this.innerRangeSeparator = nval;
      }
    },
  },
};
</script>

<style>
@import "../../../assets/css/admin/myDatePicker.css";
</style>



// WEBPACK FOOTER //
// src/components/admin/statistics/myDatePicker.vue